import { PermissionCode } from './permission';
export default [
    {
        name: 'home',
        title: 'nav.home',
        icon: 'mobile-home',
        platform: ['desktop', 'mobile'],
        requiredPermissions: [],
    }, {
        name: 'redemption',
        title: 'nav.redemptions',
        icon: 'mobile-redemption',
        platform: ['desktop', 'mobile'],
        // 拥有 Darshboard 或 Redmption 任一权限即可看到此导航
        requiredPermissions: [PermissionCode.Dashboard, PermissionCode.Redemption],
    }, {
        name: 'fulfillment_list',
        title: 'nav.fulfillment',
        icon: 'mobile-home',
        platform: ['desktop'],
        requiredPermissions: [PermissionCode.FulfillmentVoucher],
    }, {
        name: 'userCenter',
        title: 'nav.user',
        icon: 'mobile-user',
        platform: ['mobile'],
        // 用户中心为基础功能，无需权限
        requiredPermissions: [],
    },
];
